import { buildModelManager } from "../builder.js";
const DefaultGdprExportSelection = {
  __typename: true,
  id: true,
  completedAt: true,
  createdAt: true,
  customerEmail: true,
  downloadToken: true,
  errorMessage: true,
  expiresAt: true,
  exportData: true,
  exportFile: { url: true, mimeType: true, fileName: true },
  fileSize: true,
  recordCount: true,
  requestType: true,
  shopId: true,
  shopifyCustomerId: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "gdprExport";
const pluralModelApiIdentifier = "gdprExports";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultGdprExportSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultGdprExportSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultGdprExportSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultGdprExportSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultGdprExportSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultGdprExportSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultGdprExportSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByDownloadToken",
    findByField: "downloadToken",
    findByVariableName: "downloadToken",
    modelApiIdentifier,
    defaultSelection: DefaultGdprExportSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByDownloadToken",
    findByField: "downloadToken",
    findByVariableName: "downloadToken",
    modelApiIdentifier,
    defaultSelection: DefaultGdprExportSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createGdprExport",
    operationReturnType: "CreateGdprExport",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { gdprExport: { required: false, type: "CreateGdprExportInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultGdprExportSelection
  },
  {
    type: "action",
    operationName: "bulkCreateGdprExports",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateGdprExportsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultGdprExportSelection
  },
  {
    type: "action",
    operationName: "updateGdprExport",
    operationReturnType: "UpdateGdprExport",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      gdprExport: { required: false, type: "UpdateGdprExportInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultGdprExportSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateGdprExports",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateGdprExportsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultGdprExportSelection
  },
  {
    type: "action",
    operationName: "deleteGdprExport",
    operationReturnType: "DeleteGdprExport",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteGdprExports",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertGdprExport",
    operationReturnType: "UpsertGdprExport",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      gdprExport: { required: false, type: "UpsertGdprExportInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateGdprExportResult": { hasReturnType: false },
      "... on UpdateGdprExportResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultGdprExportSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertGdprExports",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertGdprExportsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultGdprExportSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "gdprExportGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const GdprExportManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultGdprExportSelection,
  operations
);
export {
  DefaultGdprExportSelection,
  GdprExportManager
};
//# sourceMappingURL=GdprExport.js.map
